import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as fromMembers from '../../reducers/members.reducer';
import * as fromRoot from '@app/reducers';
import { Role } from '@app/shared/models/role';
import { User } from '@app/shared/models/user';
import { DialogRef } from '@ngneat/dialog';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { MembersActions } from '../../actions';

@Component({
  selector: 'app-modal-detach-group',
  templateUrl: './modal-detach-group.component.html',
  styleUrls: ['./modal-detach-group.component.scss']
})
export class ModalDetachGroupComponent {

  memberToDetach: User;
  group: any;
  teamId: string;

  detachGroupSuccess$: Observable<boolean>;
  detachGroupProcessing$: Observable<boolean>;

  detachGroupForm: FormGroup;
  roles: Role[];
  submitted = false;

  constructor(private store$: Store<fromRoot.State & fromMembers.State>, private route: ActivatedRoute, public ref: DialogRef) {
    this.memberToDetach = this.ref.data.memberToDetach;
    this.group = this.ref.data.group;
    this.teamId = this.ref.data.teamId;

    this.detachGroupSuccess$ = this.store$.select(fromMembers.getMemberDetachGroupSuccess);
    this.detachGroupProcessing$ = this.store$.select(fromMembers.getMemberDetachGroupProcessing);
  }

  closeModal() {
    this.ref.close();
  }

  detachMemberFromGroup() {
    this.store$.dispatch(MembersActions.detachMemberFromGroup({ teamId: this.teamId, member: this.memberToDetach, group: this.group }));
    this.detachGroupSuccess$.subscribe(res => {
      if (res) {
        this.store$.dispatch(MembersActions.loadMember({ teamId: this.teamId, userId: this.memberToDetach.id }));
        this.store$.dispatch(MembersActions.loadMemberRoles({ teamId: this.teamId, userId: this.memberToDetach.id }));
        this.closeModal();
      }
    });
  }
}
